/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import type Mithril from 'mithril';

export interface ReviewItemCoverAttrs extends ComponentAttrs {
	coverImage: string;
	routeToReview: string;
	/** Render the cover as a link to the review instead of a plain `div`. */
	isLink?: boolean;
}

export default class ReviewItemCover extends Component<ReviewItemCoverAttrs> {
	oninit(vnode: Mithril.Vnode<ReviewItemCoverAttrs, this>) {
		super.oninit(vnode);
	}

	view(): Mithril.Children {
		const { coverImage, routeToReview, isLink } = this.attrs;

		const attrs: Mithril.Attributes = {
			className: 'ReviewItem-cover ArticleCover--medium',
			style: { backgroundImage: `url('${coverImage}')` },
		};

		if (isLink) {
			attrs.href = routeToReview;

			return <Link {...attrs}></Link>;
		}

		return <div {...attrs}></div>;
	}
}
